import { uniq } from "lodash";
import { PodcastConfig } from "components/podcast/PodcastProvider";

export const getHosts = (allData: PodcastConfig[]) => {
  const hosts = allData.map(({ host }) => host);
  return uniq(hosts);
};

interface FilterDataProps {
  podcastData: PodcastConfig[] | null;
  value: string;
  lowerBoundary?: string | number;
  filterBy: keyof PodcastConfig;
  sign?: "greater" | "less" | "between";
}

export const filterFunction = ({ podcastData, value, lowerBoundary, filterBy, sign }: FilterDataProps) => {
  if (!podcastData) return [];
  switch (sign) {
    case "greater": {
      const greaterResult = podcastData?.filter(singlePodcastData => Number(singlePodcastData[filterBy]) > Number(value));
      return greaterResult;
    }
    case "less": {
      const lesserResult = podcastData?.filter(singlePodcastData => Number(singlePodcastData[filterBy]) < Number(value));
      return lesserResult;
    }
    case "between":
      if (lowerBoundary) {
        const lowerBoundryResult = podcastData?.filter(singlePodcastData => Number(singlePodcastData[filterBy]) < Number(value) && Number(singlePodcastData[filterBy]) > lowerBoundary);
        return lowerBoundryResult;
      } else {
        return [];
      }
    default: {
      const filterByStringResult = podcastData?.filter(singlePodcastData => {
        const propertyValue = singlePodcastData[filterBy];
        if (!Array.isArray(propertyValue) && !(typeof propertyValue === "number")) {
          const lowerCaseValue = value.toLowerCase();
          const lowerCasePropertyValue = propertyValue?.toLowerCase();
          return lowerCasePropertyValue?.includes(lowerCaseValue);
        }
      });
      return filterByStringResult;
    }
  }
};
